module.exports = __webpack_public_path__ + "static/img/未标题-2.45e6bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/未标题-2.png
// module id = klqU
// module chunks = 17